export default {
  validateCredentials: 'Test credentials',
  credentialsInvalidMessage: 'Either the username or password are invalid.',
  credentialsValidMessage: 'Provided credentials are valid.',
};
